export default __webpack_public_path__ + "static/media/filling_3.5fbd570b.webp";